module.exports = __webpack_public_path__ + "images/emails/bg-page-r-09c22bc5.png";